import { z } from "zod";

import { UserDtoSchema } from "./users";

export const HistoryActionList = [
  "startExperience",
  "pauseExperience",
  "endExperience",
  "saveExperience",
  "duplicateExperience",
  "deleteExperience",
  "enableCampaign",
  "disableCampaign",
  "saveCampaign",
  "archiveCampaign",
  "confirmIntegration",
  "duplicateExperience",
] as const;

export type HistoryActionType = (typeof HistoryActionList)[number];

export const HistoryDtoSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  user: UserDtoSchema,
  experienceId: z.string().uuid().nullish(),
  action: z.enum([...HistoryActionList]),
  lastUpdateTs: z.number(),
  createdAtTs: z.number(),
});

export type HistoryDto = z.infer<typeof HistoryDtoSchema>;

export const ResourceIdKeyList = ["experienceId"] as const;
export type ResourceIdKeyType = (typeof ResourceIdKeyList)[number];
